import { useDispatch } from 'react-redux';
import { FirstBlockWithLoader } from './loaders';

export const FirstBlock = () => {
    const dispatch = useDispatch();

    return <FirstBlockWithLoader />;
};
